export default __webpack_public_path__ + "static/tree_Sway-62e7df7f6ad8c660734ed8e95ce53278.mp4";